import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import SEO from '../components/SEO';
import ClientCard from '../components/ClientCard';
import Testimonials from '../components/Testimonials';
import { clients } from '../data/clients';

const clientsJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'CollectionPage',
  name: 'Nexsol Labs — Clients',
  url: 'https://nexsollabs.com/clients',
  hasPart: clients.map((c) => ({
    '@type': 'Organization',
    name: c.name,
    address: c.region,
    industry: c.industry,
  })),
};

const clientsBreadcrumbJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://nexsollabs.com/' },
    { '@type': 'ListItem', position: 2, name: 'Clients', item: 'https://nexsollabs.com/clients' },
  ],
};

export default function Clients() {
  return (
    <>
      <SEO
        title="Clients — Pharma, Recruitment, Public Sector | Nexsol Labs"
        description="Companies and institutions Nexsol Labs has built software for — PharmaS, Abela, Bosnalijek, Fitofarm, Ladria, Nomad Partners, Faculty of Pharmacy Skopje, Alfalab, Global Net ADV. Trusted across Macedonia, Bulgaria, Serbia, Croatia, and Bosnia."
        path="/clients"
        keywords="Nexsol Labs clients, PharmaS, Abela, Bosnalijek, Fitofarm, Ladria, Nomad Partners, Faculty of Pharmacy Skopje, Alfalab, Global Net ADV, pharma software clients Macedonia"
        jsonLd={[clientsJsonLd, clientsBreadcrumbJsonLd]}
      />

      {/* HERO */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 grid-bg opacity-30" />
        <div className="container-page relative py-20 md:py-28">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="max-w-3xl"
          >
            <p className="eyebrow">Our clients</p>
            <h1 className="mt-4 font-display text-4xl font-semibold leading-tight tracking-tight text-white md:text-5xl">
              Trusted by teams across pharma,{' '}
              <span className="gradient-text">recruitment, and the public sector.</span>
            </h1>
            <p className="mt-6 text-base leading-relaxed text-white/70 md:text-lg">
              Pharmaceutical companies and their regional offices, recruitment agencies,
              municipal operators, public institutions, and marketing agencies — a small
              snapshot of who we've shipped for.
            </p>
          </motion.div>
        </div>
      </section>

      {/* CLIENTS GRID */}
      <section className="container-page pb-16 md:pb-20">
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {clients.map((c, i) => (
            <ClientCard key={c.slug} client={c} index={i} />
          ))}
        </div>
      </section>

      {/* TESTIMONIALS */}
      <Testimonials />

      {/* CTA */}
      <section className="container-page pb-20 md:pb-28">
        <div className="rounded-3xl border border-white/10 bg-white/[0.03] p-10 text-center">
          <h2 className="font-display text-2xl font-semibold text-white md:text-3xl">
            Want to be on this list?
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-white/65">
            Tell us what you're trying to build. If we're the right fit, we'd be glad
            to have your name here next.
          </p>
          <div className="mt-6 flex justify-center">
            <Link to="/contact" className="btn-primary">
              Start a conversation
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
